/**
 *
 * Asynchronously loads the component for InfoDisclamer
 *
 */

import { lazyLoad } from 'utils/loadable';

export const InfoDisclamer = lazyLoad(
  () => import('./index'),
  module => module.InfoDisclamer,
);
